const gameConfig = {
    type: Phaser.AUTO,
    parent: 'game_container',
    width: 2000,
    height: 1000,
    backgroundColor: '#d7a8ae',
    physics: {
        default: 'arcade',
        arcade: {
            gravity: { x: 0, y: 0 } // Top down game, so no gravity
        }
    }
}

export default gameConfig;